import {
  BACKSPACE,
  DELETE,
  LEFT_ARROW,
  RIGHT_ARROW
} from '@/constants'

export default {
  name: 'otpInput',

  props: {
    numInputs: {
      type: Number,
      required: true
    },
    shouldAutoFocus: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  data() {
    return {
      activeInput: 1,
      inputList: [],
      otp: [],
      oldOtp: []
    }
  },

  computed: {
    isLastInputActive: function() {
      return this.activeInput === this.numInputs
    },

    allInputsFilled: function() {
      return this.otp.length === this.numInputs
    },

    otpCode: function() {
      let code = ''
      this.otp.forEach(digit => {
        code = code.concat(digit)
      })

      return code
    }
  },

  methods: {
    handleOnClick() {
      if (this.allInputsFilled) {
        this.focusLastInput()
      } else {
        this.focusFirstEmptyInput()
      }
    },

    setFocus(index) {
      const input = this.inputList[index]
      if (input) {
        input.focus()
        input.select()
      } else {
        this.focusFirstEmptyInput()
      }
    },

    blur() {
      this.inputList[this.activeInput - 1].focus()
      this.inputList[this.activeInput - 1].blur()
    },

    focusFirstEmptyInput() {
      const index = this.getFirstEmtpyInputFocusIndex()
      if (index > 0) {
        this.focusInput(index)
      }
    },

    focusInput(input) {
      this.activeInput = this.getInputIndex(input)
      this.setFocus(this.activeInput - 1)
    },

    handleOnChange(event) {
      const value = this.getValueFromEvent(event)
      if (value.length > 1) {
        this.autocomplete(value)
      } else {
        if (value !== '') {
          this.setInputValue(value)
        }
      }

      this.checkOtpInputFocus()
    },

    handleOnKeyDown(event) {
      switch (event.keyCode) {
        case BACKSPACE:
          event.preventDefault()
          if (this.isEmptyInput(this.activeInput)) {
            this.focusPrevInput()
          }

          this.setInputValue('')
          this.focusFirstEmptyInput()
          break
        case DELETE:
          event.preventDefault()
          this.setInputValue('')
          this.focusInput(this.activeInput)
          break
        case LEFT_ARROW:
        case RIGHT_ARROW:
          event.preventDefault()
          this.focusInput(this.activeInput)
          break
        default:
          break
      }
    },

    handleOnPaste(event) {
      event.preventDefault()
      this.autocomplete(event.clipboardData.getData("text"))
      this.checkOtpInputFocus()
    },

    focusNextInput() {
      this.focusInput(this.activeInput + 1)
    },

    focusPrevInput() {
      this.focusInput(this.activeInput - 1)
    },

    focusLastInput() {
      this.focusInput(this.otp.length + 1)
    },

    changeCodeAtFocus(value, index = this.activeInput - 1) {
      this.oldOtp = [...this.otp]
      this.setOtpDigit(value, index)
      this.$emit('on-change', this.otpCode);
      if (this.allInputsFilled) {
        this.$emit('on-complete', this.otpCode)
      }
    },

    getInputId(index) {
      return `otp${index}`
    },

    setOtpDigit(value, index) {
      if (value) {
        this.$set(this.otp, index, value.toString())
      } else {
        this.otp.splice(index, 1)
      }
    },

    setInputValue(value, index = this.activeInput - 1) {
      this.changeCodeAtFocus(value, index);
      this.inputList[index].value = value
    },

    isEmptyInput(index) {
      return !this.inputList[index - 1].value
    },

    getFirstEmtpyInputFocusIndex() {
      for (let i = 1; i <= this.numInputs; i++) {
        if (!this.inputList[i - 1].value) {
          return i
        }
      }

      return -1
    },

    getValueFromEvent(e) {
      return e ? e.data || (e.target && e.target.value) : e
    },

    getInputIndex(index) {
      if (index < 1) {
        return 1
      }

      if (index > this.numInputs) {
        return this.numInputs
      }

      return index
    },

    autocomplete(code) {
      this.otp = []
      for (let i = 0; i < this.inputList.length; i++) {
        this.setInputValue(code.charAt(i) || '', i)
      }
    },

    checkOtpInputFocus() {
      if (this.allInputsFilled) {
        this.blur()
      } else {
        this.focusFirstEmptyInput()
      }
    }
  },

  mounted: function() {
    this.inputList = document.querySelectorAll('input[type="number"]')

    this.inputList.forEach(input => {
      input.addEventListener('paste', this.handleOnPaste)
    })

    if (this.shouldAutoFocus) {
      this.focusFirstEmptyInput()
    }
  }
}